import { gql } from "@apollo/client";

export const SEND_SUPPORT_EMAIL = gql`
  mutation supportEmail(
    $name: String!
    $surname: String!
    $email: String!
    $message: String!
  ) {
    supportEmail(
      name: $name
      surname: $surname
      email: $email
      message: $message
    )
  }
`;
